<div class="table-container">
  <table mat-table [dataSource]="dataSource" class="pricing-product-table">
    <!-- Product name caption -->
    <ng-container matColumnDef="caption">
      <th mat-header-cell *matHeaderCellDef colspan="5">
        {{ label }}
      </th>
    </ng-container>

    <!-- siteName Column -->
    <ng-container matColumnDef="siteName">
      <td mat-cell *matCellDef="let element">
        <strong>{{ element.siteName }}</strong>
        <br />
        <span>{{ element.siteAddress }}</span>
      </td>
    </ng-container>

    <!-- Pricing input columns -->
    <ng-container
      *ngFor="let column of priceColumns"
      matColumnDef="{{ column }}"
    >
      <td mat-cell *matCellDef="let element">
        <div class="easy-form pe-4">
          <mat-form-field *ngIf="element[column + 'Enabled']">
            <div
              class="form-field-container"
              [class.warning]="element[column + 'Status'] === 'INACTIVE'"
            >
              <ng-container
                *ngIf="
                  element[column + 'Status'] === 'ACTIVE';
                  else notActiveIcon
                "
              >
                <mat-icon matPrefix>done</mat-icon>
              </ng-container>
              <ng-template #notActiveIcon>
                <mat-icon
                  matPrefix
                  fontSet="material-icons-outlined"
                  [matTooltip]="'PRICING.INACTIVE_SITE_TOOLTIP' | translate"
                  >warning_amber</mat-icon
                >
              </ng-template>

              <input
                class="prefix suffix"
                matInput
                [(ngModel)]="element[column]"
                type="number"
                (wheel)="$event.preventDefault()"
                step="1"
                min="0.000001"
                appLimitDecimalDigits
                [decimals]="2"
                [isNumberInput]="true"
              />
              <span matTextSuffix>Ft</span>
            </div>
          </mat-form-field>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="['caption']"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</div>
